<template>
  <div
    class="media-image"
  >
    <button
      v-if="canDelete"
      type="button"
      class="delete"
      style="position: absolute; top: 4px; right: 4px; z-index: 1"
      @click="$emit('delete')"
    />
    <img
      v-if="imageUrl"
      :src="imageUrl"
      :alt="name"
      style="object-fit: cover;height: 100%; width: 100%;"
      ratio="6by4"
    >
  </div>
</template>

<script>
export default {
  props: {
    error: {
      default: null,
      type: String
    },
    file: {
      required: true,
      validator (i) {
        return i instanceof Object || i instanceof File;
      }
    },
    canDelete: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      blob: null
    };
  },
  computed: {
    name () {
      if (this.file.file_name) {
        return this.file.file_name;
      }
      return this.file.name;
    },
    size () {
      return this.file.size.fileSizeFormat();
    },
    fullType () {
      let type = "file";

      if (this.file.mime_type) {
        type = this.file.mime_type;
      }

      if (this.file.type) {
        type = this.file.type;
      }

      return type;
    },
    type () {
      let parts = this.fullType.split("/");
      return parts[0];
    },
    extension () {
      let parts = this.fullType.split("/");
      return parts[parts.length - 1];
    },
    url () {
      if (this.file.url) {
        return this.file.url;
      }
      return null;
    },
    imageUrl () {
      if (this.type == "image") {
        if (this.url) {
          return this.url;
        }
        if (this.blob) {
          return this.blob;
        }
      }
      return null;
    }
  },
  watch: {
    file: {
      handler () {
        this.blob = null;

        if (this.file instanceof File) {
          var reader = new FileReader();
          reader.readAsDataURL(this.file);
          reader.onload = () => {
            this.blob = reader.result;
          };
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped>

.media-image {
  position: relative; /* anchors the delete button to its own thumbnail */
  height: 80px;
  width: 100px;
  border: 1px $grey-lighter solid;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: $grey-darker;
  border-radius: 2px;
  background-color: $white-bis;
  overflow: hidden;
  margin: 10px;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: center;
  }
}
</style>
